export const treasury_annual_report = [
  {
    id: 1,
    name: 'final-alternative-and-blended-finance-framework-22.04.2025',
    summary: 'shortsummary/final-alternative-and-blended-finance-framework-22.04.2025.html',
    link: 'final-alternative-and-blended-finance-framework-22.04.2025.pdf',
    audio_en: 'audio/en/final-alternative-and-blended-finance-framework-22.04.2025_en.mp3',
    audio_af: 'audio/af/final-alternative-and-blended-finance-framework-22.04.2025_af.mp3',
    audio_xh: 'audio/xh/final-alternative-and-blended-finance-framework-22.04.2025_xh.mp3'
  },
  {
    id: 2,
    name: 'quarterly-consolidated-statement-on-municipal-finances-per-s71-7-of-the-mfma-q3-2024-25',
    summary: 'shortsummary/quarterly-consolidated-statement-on-municipal-finances-per-s71-7-of-the-mfma-q3-2024-25.html',
    link: 'quarterly-consolidated-statement-on-municipal-finances-per-s71-7-of-the-mfma-q3-2024-25.pdf',
    audio_en: 'audio/en/quarterly-consolidated-statement-on-municipal-finances-per-s71-7-of-the-mfma-q3-2024-25_en.mp3',
    audio_af: 'audio/af/quarterly-consolidated-statement-on-municipal-finances-per-s71-7-of-the-mfma-q3-2024-25_af.mp3',
    audio_xh: 'audio/xh/quarterly-consolidated-statement-on-municipal-finances-per-s71-7-of-the-mfma-q3-2024-25_xh.mp3'
  },
   {
    id: 3,
    name: 'wc-provincial-treasury-2024_25-annual-report',
    summary: 'shortsummary/wc-provincial-treasury-2024_25-annual-report.html',
    link: 'wc-provincial-treasury-2024_25-annual-report.pdf',
    audio_en: 'audio/en/wc-provincial-treasury-2024_25-annual-report_en.mp3',
    audio_af: 'audio/af/wc-provincial-treasury-2024_25-annual-report_af.mp3',
    audio_xh: 'audio/xh/wc-provincial-treasury-2024_25-annual-report_xh.mp3'
  }

];